import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import clsx from "clsx";
import { I18nLangMap } from "@/constants";
import { CorrectSvg } from "@/assets/icons";
import { setCookie } from "@/utils";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const LocaleMenu = () => {
  const { t, i18n } = useTranslation();
  
  const localeList = [
    {
      key: "en",
      name: t("locale_name_en"),
      nativeName: "English",
    },
    {
      key: "es",
      name: t("locale_name_es"),
      nativeName: "Español",
    },
    {
      key: "pt",
      name: t("locale_name_pt"),
      nativeName: "Português",
    },
    {
      key: "ru",
      name: t("locale_name_ru"),
      nativeName: "Pусский",
    },
    {
      key: "fr",
      name: t("locale_name_fr"),
      nativeName: "Français",
    },
    {
      key: "de",
      name: t("locale_name_de"),
      nativeName: "Deutsch",
    },
    {
      key: "cn",
      name: t("locale_name_cn"),
      nativeName: "简体中文",
    },
    {
      key: "tw",
      name: t("locale_name_tw"),
      nativeName: "正體中文",
    },
    {
      key: "jp",
      name: t("locale_name_jp"),
      nativeName: "日本語",
    },
    { 
      key: "id",
      name: t("locale_name_id"),
      nativeName: "Bahasa Indonesia",
    },
    { 
      key: "it",
      name: t("locale_name_it"),
      nativeName: "Italiano",
    },
    { 
      key: "th",
      name: t("locale_name_th"),
      nativeName: "ภาษาไทย",
    },
    { 
      key: "vi",
      name: t("locale_name_vi"),
      nativeName: "Tiếng Việt",
    },
    { 
      key: "tr",
      name: t("locale_name_tr"),
      nativeName: "Türkçe",
    },
    { 
      key: "pl",
      name: t("locale_name_pl"),
      nativeName: "Polski",
    },
    { 
      key: "nl",
      name: t("locale_name_nl"),
      nativeName: "Nederlands",
    },
    { 
      key: "ko",
      name: t("locale_name_ko"),
      nativeName: "한국어",
    },
  ]

  const handleChange = (item: any) => {
    // if (!["id", "it", "th", "vi", "tr", "pl", "nl", "ko"].includes(item.key)) {
    //   setCookie("locale", I18nLangMap[item.key]);
    // }
    setCookie("locale", I18nLangMap[item.key]);
    i18n.changeLanguage(item.key);
  }

  return (
    <OverlayScrollbarsComponent
      className={styles["locale_menu"]}
      style={{}}
      defer
    >
      <ul
         className={styles["locale_list"]}
      >
        {localeList.map(item => (
          <li
            key={item.key}
            className={clsx(
              styles["locale_item"],
              i18n.language === item.key && styles["active"],
            )}
          >
            <button
              className={styles["locale_item_button"]}
              onClick={() => handleChange(item)}
            >
              <span className={styles["locale_item_name"]}>{item.name}</span>
              <span className={styles["locale_item_native_name"]}>{item.nativeName}</span>

              {i18n.language === item.key && (
                <CorrectSvg
                  className={styles["active_svg"]}
                  fill="#414751"
                ></CorrectSvg>
              )}
            </button>
          </li>
        ))}
      </ul>
    </OverlayScrollbarsComponent>
  )
}

export default LocaleMenu;